import React, { useEffect, useState } from 'react';
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { injectIntl } from 'react-intl'
import { useDispatch } from 'react-redux';
import { agenciesChangeStatusRequest } from '../../store/agencies/actions';

function SamplingConfirmation({  intl: { messages }, show, cancel, close, id, sample }) {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
      id: null,
      status: 0,
      notes: '',
    });

    const clear = () => {
      setFormData({
        id: sample.id,
        status: 0,
        notes: '',
      });
    }

    useEffect(() => {
      if (sample) {
        setFormData({
          id: sample.id,
          status: sample.status,
          notes: sample.notes,
        })
      }
    }, [sample])

    const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(agenciesChangeStatusRequest(formData))
      setTimeout(() => {
        clear();
        close();
      }, 1000);
    }

    return (
        <div className={show ? 'sampling-modal_container show' : 'sampling-modal_container'}>
            <div className='sampling-modal_container_content'>
                <CancelIcon className='sampling-modal_container_content_close' onClick={() => {
                    clear();
                    close();
                  }} />
                <h3>{messages.agencies.form.title}</h3>
                <div className='sampling-modal_container_content_form'>
                  <div className='form-group'>
                        <label className="checkbox-container">{messages.agencies.form.deposited}
                            <input type="radio" name="status" 
                                    disabled={sample?.status > 1} 
                                    checked={formData.status === 2}
                                    value={2}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            status: parseInt(e.target.value),
                                        });
                                    }} />
                            <span className="checkmark"></span>
                        </label>
                        <label className="checkbox-container">{messages.agencies.form.not_deposited}
                            <input type="radio" name="status" 
                                    disabled={sample?.status > 1}
                                    checked={formData.status === 3}
                                    value={3}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData, 
                                            status: parseInt(e.target.value),
                                        });
                                    }} />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <div className='form-textarea'>
                        <label htmlFor='sample_notes' >{messages.agencies.form.notes}</label>
                        <textarea id="sample_notes" name="sample_notes" rows={4}
                                value={formData.notes} 
                                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                >
                      
                        </textarea>
                    </div>
                </div>
                <div className='actions'>
                    <button type='button' onClick={(e) => {
                        handleSubmit(e);
                    }}>{messages.agencies.form.confirm}</button> 
                    <button type='button' className='cancel' onClick={(e) => {
                        e.preventDefault();
                        clear();
                        cancel();
                    }}>{messages.agencies.form.cancel}</button> 
                </div>
                
            </div>
        </div>
    )
}

export default injectIntl(SamplingConfirmation)